import {
    Component,
    Input
} from '@angular/core';
import {
    Api
} from '../../providers';
import {
    CrudProvider
} from '../../providers/crud/crud';

@Component({
    selector: 'carrito-producto',
    templateUrl: 'carrito-producto.html'
})
export class CarritoProductoComponent {
    @Input('producto') producto: any;
    @Input('id') id: string;
    constructor(private _api: Api, private _crud: CrudProvider) {}

    eliminar() {
        this._crud.borrar('producto').subscribe((loading) => {
            this._api.delete('carrito', this.id).subscribe(() => {
                loading.dismiss();
            }, err => {
                loading.dismiss();
            });
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/carrito-producto/carrito-producto.ts